export const COLORS = {
  navy: '#00247D', red: '#CF142B', gold: '#E0A800', ink: '#0F172A', slate: '#475569', muted: '#94A3B8',
};

export const CARD_TONES = {
  normal: { strip: '#E8EDF8', stripText: '#00247D', stroke: '#C5CFE2', sw: 0.7 },
  lb: { strip: '#EEF1F5', stripText: '#475569', stroke: '#CBD5E1', sw: 0.7 },
  final: { strip: '#00247D', stripText: '#FFFFFF', stroke: '#E0A800', sw: 1.3 },
  placement: { strip: '#FEF3C7', stripText: '#92400E', stroke: '#F2C14E', sw: 0.9 },
};

export const HEADER_TONES = {
  normal: ['#E8EDF8', '#00247D'],
  lb: ['#EEF1F5', '#475569'],
  final: ['#00247D', '#FFFFFF'],
  champ: ['#FCD34D', '#00247D'],
};

export function lineStyle(item, fs) {
  const thick = Math.max(0.6, fs * 0.13);
  const thin = Math.max(0.45, fs * 0.085);
  if (item.tone === 'divider') return { stroke: '#CBD5E1', width: 0.6, dash: '3 3' };
  if (item.tone === 'gold') return { stroke: COLORS.gold, width: thick };
  if (item.stub) return { stroke: '#B8C3D6', width: thin, dash: `${fs * 0.35} ${fs * 0.3}` };
  const dash = item.dashed ? `${fs * 0.35} ${fs * 0.3}` : undefined;
  if (item.done) return { stroke: item.tone === 'lb' ? '#475569' : COLORS.navy, width: thick, dash };
  return { stroke: '#AEB9CE', width: thin, dash };
}

// Rounded rectangle path with per-corner radii [tl, tr, br, bl].
export function rr(x, y, w, h, [tl, tr, br, bl]) {
  const arc = (r, ex, ey) => (r ? `A${r},${r} 0 0 1 ${ex},${ey}` : '');
  return `M${x + tl},${y} H${x + w - tr} ${arc(tr, x + w, y + tr)} V${y + h - br} ${arc(br, x + w - br, y + h)} H${x + bl} ${arc(bl, x, y + h - bl)} V${y + tl} ${arc(tl, x + tl, y)} Z`;
}

export const TROPHY_PATHS = [
  'M6 9H4.5a2.5 2.5 0 0 1 0-5H6',
  'M18 9h1.5a2.5 2.5 0 0 0 0-5H18',
  'M4 22h16',
  'M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22',
  'M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22',
  'M18 2H6v7a6 6 0 0 0 12 0V2Z',
];

export const shortDate = (d) => {
  const dt = new Date(`${d}T00:00:00`);
  return Number.isNaN(dt.getTime()) ? d : dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};
